import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '@app/shared/services/auth.service';
import { ProfileService } from '../services/profile.service';
import { ProfileBaseGuard } from './profile-base.guard';
import { LDFlagsService } from '@dg/shared-services';

/**
 * Route guard to control the accessibility of the /profile/:id/overview route
 */
@Injectable({
  providedIn: 'root',
})
export class ProfileOverviewGuard extends ProfileBaseGuard {
  constructor(
    protected authService: AuthService,
    private ldFlagsService: LDFlagsService,
    protected profileService: ProfileService,
    protected router: Router
  ) {
    super(router, profileService, authService);

    // Op settings takes precedence
    if (this.authService.authUser?.hideOverviewTab) {
      this.isAuthorized = false;
    } else {
      this.isAuthorized = this.hasFeature && this.isAuthorized;
    }
  }

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    if (!this.isAuthorized) {
      const parentUrl = super.getParentUrl(route, state);
      return this.router.parseUrl(`${parentUrl}skills`);
    } else {
      const useNewProfile = this.ldFlagsService.showProfileOverviewV2;

      if (useNewProfile) {
        const vanityUrl = route.parent.params.id;
        return this.router.parseUrl(`profile/${vanityUrl}/overview-v2`);
      }
      return this.isAuthorized;
    }
  }

  public get hasFeature(): boolean {
    return this.ldFlagsService.showProfileOverviewTab;
  }
}
